import { useMemo } from "react";

import { useServer } from "@shared/hooks/useServer/useServer";

type Platform = {
  isAndroid: boolean;
  isIOS: boolean;
  isDesktop: boolean;
};

const usePlatform = (): Platform => {
  const { ssr, userAgent: serverUserAgent } = useServer();

  const userAgent = ssr ? serverUserAgent : window.navigator.userAgent;

  const platform: Platform = useMemo(() => {
    if (!userAgent) {
      return {
        isAndroid: false,
        isIOS: false,
        isDesktop: true,
      };
    }
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isDesktop = !isAndroid && !isIOS;

    return {
      isAndroid,
      isIOS,
      isDesktop,
    };
  }, [userAgent]);

  return platform;
};

export { usePlatform };
